import "./animations";
import "./custom";
import "./customizer";
import "./jquery.scrollify.js";
import "./navigation.js";
import "./single.js";
import "./skip-link-focus-fix.js";

// Styles
import '../sass/main.scss'